import camelcaseKeys from "camelcase-keys";
import * as v from "valibot";

const flatsCreationSchema = v.pipe(
    v.looseObject({}),
    v.transform((x) => camelcaseKeys(x, { deep: true })),
    v.object({
        jobId: v.pipe(
            v.string(),
            v.uuid()),
    }));

const flatsStatusSchema = v.pipe(
    v.looseObject({}),
    v.transform((x) => camelcaseKeys(x, { deep: true })),
    v.variant("status", [
        v.object({
            jobId: v.pipe(
                v.string(),
                v.uuid()),
            status: v.literal("succeeded"),
            zipPath: v.string(),
        }),
        v.object({
            jobId: v.pipe(
                v.string(),
                v.uuid()),
            status: v.union([
                v.literal("accepted"),
                v.literal("searching_from_db"),
                v.literal("creating_files"),
                v.literal("zipping"),
                v.literal("no_data"),
                v.literal("failed"),
                v.literal("not_found")]),
            zipPath: v.null(),
        }),
    ]));

export type FlatsCreation = v.InferOutput<typeof flatsCreationSchema>;
export type FlatsStatus = v.InferOutput<typeof flatsStatusSchema>;

/**
 * 与えられたデータをフラットファイル作成情報データとしてパースする。
 *
 * @param data 対象のデータ
 * @returns パース結果
 */
export const parseFlatsCreation = (data: unknown) => v.parse(flatsCreationSchema, data);

/**
 * 与えられたデータをフラットファイル作成状況情報データとしてパースする。
 *
 * @param data 対象のデータ
 * @returns パース結果
 */
export const parseFlatsStatus = (data: unknown) => v.parse(flatsStatusSchema, data);
